import { Injectable } from '@angular/core';

import { IMessageData } from '@app/layout/message/message.model';

import { MessageDOS } from './message-dos.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  constructor(private _messageDOS: MessageDOS) {}

  showSuccessMessage(text: string): void {
    const message: IMessageData = {
      forSuccess: true,
      text
    };

    this._addMessageToList(message);
  }

  showErrorMessage(text: string): void {
    const message: IMessageData = {
      forSuccess: false,
      text
    };

    this._addMessageToList(message);
  }

  removeMessageFromList(message: IMessageData): void {
    const messages = this._messageDOS.getMessageListSnapshot();
    const newMessages = messages.filter((element) => element !== message);

    this._messageDOS.updateMessageList(newMessages);
  }

  private _addMessageToList(message: IMessageData): void {
    const messages = this._messageDOS.getMessageListSnapshot();
    const newMessages = [message, ...messages];

    this._messageDOS.updateMessageList(newMessages);
  }
}
